import React, { memo, PropsWithChildren } from 'react';

import { ContactSection, Partner } from '@/app/_components/common';
import { FloatingCTA, Footer, Header } from '@/app/_components/layout';

interface IProps extends PropsWithChildren {}

const GlobalLayout: React.FC<IProps> = ({ children }) => {
	return (
		<>
			<Header />
			<div className="pt-[102px] sm:pt-[120px] lg:pt-[136.85px]">
				{children}
				<ContactSection />
				<Partner />
				<FloatingCTA />
				<Footer />
			</div>
		</>
	);
};

export default memo(GlobalLayout);
